import { DateField, DateTimeField, FieldTypes, getFieldNowValue, TimeField } from '@hb/shared'
import { useCallback } from 'react'
import { ActionButton } from '../../../Buttons'

interface SetToNowButtonProps {
  field: DateField | DateTimeField | TimeField
  onChange: (value: any) => void
  disabled?: boolean
  readOnly?: boolean
}

export const SetToNowButton = ({ field, onChange, disabled, readOnly }: SetToNowButtonProps) => {
  const handleClick = useCallback(() => {
    onChange(getFieldNowValue(field))
  }, [field, onChange])

  return (
    <ActionButton
      size="xs"
      fontSize="sm"
      onClick={handleClick}
      isDisabled={disabled || readOnly}
      mb="auto"
      tabIndex={-1}
      flexShrink={0}>
      Set to {field.type === FieldTypes.DATE ? 'Today' : 'Now'}
    </ActionButton>
  )
}
